export class UpdateSessionRequest {
    'stateDelta';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "stateDelta",
            "baseName": "state_delta",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateSessionRequest.attributeTypeMap;
    }
    constructor() {
    }
}
